import React from "react";
import "../styles/Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <p>© 2025 Jeremiah Obembe. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
